import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ServicesContainer from "./services/ServicesContainer";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";

const DEFAULT_TAB = "services";

const ClientTabsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "services": {
        return 0;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper height="auto">
      <StyledTabsHead
        className="tab-head"
        orientation="horizontal"
      >
        <Tabs
          value={queryParams?.currentTab ?? DEFAULT_TAB}
          indicatorColor="secondary"
          onChange={handleChange}
          orientation="horizontal"
          className="tab-head-buttons"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={t("details.tabs.services")} value="services" />
        </Tabs>
      </StyledTabsHead>
      <StyledTabsBody className="tab-body" style={{overflow: "inherit"}}>
        <TabPanel
          value={tabValue}
          index={0}
        >
          <ServicesContainer match={match} />
        </TabPanel>
      </StyledTabsBody>
    </StyledContentWrapper>
  );
};

export default ClientTabsContainer;